import script from "./section4-parallax.vue?vue&type=script&setup=true&lang=js"
export * from "./section4-parallax.vue?vue&type=script&setup=true&lang=js"

import "./section4-parallax.vue?vue&type=style&index=0&id=2fd69258&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fd69258"]])

export default __exports__